import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { ModuleMenu, INSTRUCTION } from '../../../models/common';
import { HeadService } from '../../../services/common/headservice';
import { CommonService } from '../../../services/common.service';
import { GrantsSummaryService } from '../../../services/grants/grants-summary.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eap-user-instructions-modal',
  templateUrl: './eap-user-instructions-modal.component.html',
  styleUrls: ['./eap-user-instructions-modal.component.scss']
})
export class EapUserInstructionsModalComponent implements OnInit {
  id: number;
  isAck = false;
  menudata: ModuleMenu;
  instruction: INSTRUCTION;
  title: string = "";
  description: string = "";
  @Input() Content:any;
  //@Input() ApplicationType:string="";
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private dataShare: IstDataShareService,
    private header: HeadService,
    private commonService: CommonService,
    private summaryService: GrantsSummaryService,
  ) { }

  ngOnInit() {
    this.getEAPInstructions();
  }

  add() {
   
   this.modalRef.dismiss();
   this.commonService.refreshApplicationPage("","eap", this.Content.ApplicationType);
  }
  getEAPInstructions() {
   let ApplicationType = this.Content.ApplicationType; 
    this.summaryService.getInstruction(ApplicationType).subscribe(summary => {
      this.instruction = summary;
      if (this.instruction != null) {
        this.title = this.instruction.NAME;
        this.description = this.instruction.DESCRIPTION;
      }

    });
  }
   isChecked($event){
    this.isAck = !this.isAck;
  }
}
